import React, { useState, useEffect, useRef } from "react";
import gsap from "gsap";
import classes from "./SectionScroll.module.css";

const SectionScroll = (props) => {
  const [color, setColor] = useState("#6595c2");
  const container = useRef(null);
  // console.log("height",props.height)
  useEffect(() => {
    if (props.height !== 0 && props.height !== 100) {
      setColor("#FCCE01");
      gsap.to(container.current, {
        duration: 0.5,
        xPercent: 5,
      });
    } else {
      setColor("#6595c2");
      gsap.to(container.current, {
        duration: 0.5,
        xPercent: 0,
      });
    }


  },[props.height]);

  const scroll = () => {
    if (props.top === 1) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      const element = document.getElementsByClassName(props.container)[0];
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  return (
    <div
      className={classes.container}
      ref={container}
      style={{ height: `${props.size}%` }}
      onClick={scroll}
    >
      <div className={classes.indicator}>
        <div
          className={classes.progress}
          style={{ height: `${props.height}%` }}
        ></div>
      </div>
      <div className={classes.title} style={{ color }}>
        {props.title}
      </div>
    </div>
  );
};
export default SectionScroll;
